<div class="fullcontainer">
    <div class="sheet">
      <h1 class='header'>Delete POD NO: {{ this.pod.id }}</h1>
  
      <p>Are you sure you wish to delete this POD? 
          This will delete it from the system. If you wish to restore please contact support.</p>
  
        
      <button type="submit" class="btn btn-danger" (click)='this.onCancelClicked()'>Yes! I'm Sure!</button>&nbsp;
      <button type="button" class="btn btn-primary" routerLink='/pods'>No! Take me back!</button>
    </div>
  </div>
  
